import React, { useState } from "react";
import DropMenu from "../DropMenu";
import PersonIcon from '@mui/icons-material/Person';
import { useDispatch, useSelector } from "react-redux";
import { useLanguageList } from "../../../fetch/fetchClassificationItems";
import { useIsAuthenticated, useMsal } from "@azure/msal-react";
import useLiteratureCurrentView from "../hooks/useLiteratureCurrentView";
import { exitFullScreen, isInFullScreen } from '../../../helpers/fullScreenHelper';
import { clearFilters } from "../../../redux/libraryFiltersSlice";
import ChangeDefaultLanguageDialog from "./ChangeDefaultLanguage";
import { useNotification } from "../../../hooks";
import storedVersion from "../../../storedVersion";

export default function UserDropMenu() {
    const { instance } = useMsal();
    const { showPromptModal } = useNotification();
    const isAuthenticated = useIsAuthenticated();
    const { isInDocumentListView, isInFaultList, isInServiceLogList } = useLiteratureCurrentView();
    const [showLanguageChange, setShowLanguageChange] = useState(false);
    const dispatch = useDispatch();
    const accountNumber = useSelector((state) => state.permissions.accountNumber)
    const defaultLanguage = useSelector((state) => state.permissions.language)
    const { deployVersion } = useSelector((state) => state.permissions)
    const { DeployVersion: storedDeployVersion } = storedVersion;

    let isUpToDate = deployVersion === storedDeployVersion;

    const { languages } = useLanguageList();
    let languageLabel = 'Change Default Language';
    if (!!defaultLanguage && !!languages && languages.length > 0) {
        const filteredLanguages = languages.filter(lang => lang.code == defaultLanguage);
        if (!!filteredLanguages && filteredLanguages.length > 0) {
            languageLabel = `Default Language: ${filteredLanguages[0].nameLocal}`;
        }
    }

    if (!isAuthenticated || (!isInDocumentListView && !isInFaultList && !isInServiceLogList)) {
        return null;
    }

    const logout = () => {
        instance.logoutRedirect();
    }

    const handleLogoutClick = () => {
        if (isInFullScreen()) {
            exitFullScreen();
        }

        showPromptModal('Log out?', 'Are you sure you want to log out?', () => {
            dispatch(clearFilters());
            logout();
        })
    }

    return (
        <>
            <DropMenu
                label={<PersonIcon />}
                subItems={!!accountNumber ? [
                    { label: `Dealer: ${accountNumber}`, onClick: () => { } },
                    { label: languageLabel, onClick: () => setShowLanguageChange(true) },
                    { label: !isUpToDate ? `Cached: ${storedDeployVersion}` : `Up To Date: ${deployVersion}`, onClick: () => { } },
                    { label: 'Log Out', onClick: handleLogoutClick }
                ] : [
                    { label: languageLabel, onClick: () => setShowLanguageChange(true) },
                    { label: !isUpToDate ? `Cached: ${storedDeployVersion}` : `Up To Date: ${deployVersion}`, onClick: () => { } },
                    { label: 'Log Out', onClick: handleLogoutClick }
                ]}
            />
            <ChangeDefaultLanguageDialog
                open={showLanguageChange}
                onClose={() => setShowLanguageChange(false)}
            />
        </>
    );
}